import React from "react"
import { FlexContainer, Markdown } from "@carrotfertility/carotene"

const fixMarkdown = {
  ul: {
    listStyle: "none" /* Remove default bullets */,
    marginLeft: "-1.5em"
  }
}
const wrapper = ({ children }): JSX.Element => (
  <FlexContainer direction="column" gap="small" sx={fixMarkdown}>
    {children}
  </FlexContainer>
)

export const StackedMarkdown = ({ source }: { source: string }): JSX.Element => (
  <Markdown source={source} as={wrapper} />
)
